import { WeatherTableHeader } from "../weather-header-table/WeaterHeaderTable";
import { kuwaitForecastType } from "@/schemas/kuwait-forecast-schema";

import WeatherState from "../weather-state/WeatherState";

import "./style.scss";

type WeatherInfoTableProps = {
	forecastData: kuwaitForecastType | null;
};

export const WeatherInfoTable = ({ forecastData }: WeatherInfoTableProps) => {
	return (
		<div className="weather-info-table">
			<WeatherTableHeader />
			<WeatherState forecastData={forecastData} />
		</div>
	);
};

export default WeatherInfoTable;
